export const CellShadowStyles = {
  position: 'absolute',
  left: 0,
  top: 0,
  bottom: 0,
  right: 0,
  boxShadow: '-5px 0px 10px 0px rgba(0, 0, 0, 0.09)',
};
